import apiClient from "@/services/apiClient";

export default {
    data() {
        return {
            ordersApiUrl: process.env.VUE_APP_ORDERS_API_URL
        }
    },
    methods: {
        async getDomesticLabel(orderIds, weight, packageType = "") {
            const payload = { weight: weight, orderIds: orderIds, packageType: packageType };

            const {data} = await apiClient.post(`${this.ordersApiUrl}/shipping/label/domestic`, payload);

            return data;
        },
        async getForeignLabel(orderIds, weight) {
            const payload = { orderIds: orderIds, weight: weight };

            const {data} = await apiClient.post(`${this.ordersApiUrl}/shipping/label/foreign`, payload);

            return data;
        },
        async getForeignLabelFedEx(orderIds, weight, packageType, rateId, resolvedAddress) {
            const payload = { orderIds: orderIds, weight: weight, packageType: packageType, rateId, resolvedAddress };

            const {data} = await apiClient.post(`${this.ordersApiUrl}/shipping/label/fedex`, payload);

            return data;
        },
        async validateFedexAddress(orderIds) {
            const payload = { orderIds };

            const {data} = await apiClient.post(`${this.ordersApiUrl}/shipping/validate/fedex`, payload);

            return data;
        },
        async sendShippingConfirmation(orderIds) {
            const payload = { orderIds };

            const {data} = await apiClient.post(`${this.ordersApiUrl}/shipping/email/confirmation`, payload);

            return data;
        },
        async getShipmentData(shipmentId) {

            const {data} = await apiClient.get(`${this.ordersApiUrl}/shipping/shipment/${shipmentId}`);

            return data;
        },
        async getLabelData(trackingNumber) {

            const {data} = await apiClient.get(`${this.ordersApiUrl}/shipping/label/${trackingNumber}`);

            return data;
        },
        async getShipmentsForDate(date) {

            const {data} = await apiClient.get(`${this.ordersApiUrl}/shipping/shipments/${date}`);

            return data;
        },
        async cancelLabel(labelId) {

            const {data} = await apiClient.post(`${this.ordersApiUrl}/shipping/label/cancel/${labelId}`);

            return data;
        },
        async addressChosen(orderIds, validatedAddress, customerAddress, type) {
            const payload = { orderIds: orderIds, validatedAddress: validatedAddress, customerAddress: customerAddress, type: type };

            const {data} = await apiClient.post(`${this.ordersApiUrl}/shipping/address/chosen`, payload);

            return data;
        }
    }
};